module.exports = __webpack_public_path__ + "static/supria-black-webfont-a9373b92070a65d18378744423f53858.woff";